type TypeProps = {
  validator: string;
  estimated: string;
  rewards: string;
  total: string;
};

import { completedDelegationRows } from './data';

import GridTable from 'components/grid-table/grid-table';
import { columnsCompletedDelegation } from 'utils/columns-table';

const CompletedDelegationPoolsTable = () => {
  return (
    <GridTable<TypeProps>
      uniqueKey="completed-delegation"
      hover
      cols={4}
      variant="delegation"
      loading={false}
      columns={columnsCompletedDelegation}
      hasMore={false}
      data={completedDelegationRows}
    />
  );
};

export default CompletedDelegationPoolsTable;
